import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, change } from 'redux-form';
import moment from 'moment';
import MokaDatePicker from './MokaDatePicker';

const validate = values => {
  const errors = {};
  if (!values.amount_received || values.amount_received < 1) {
    errors.amount_received = 'Please enter a value greater than or equal to 1';
  }
  if (!values.payment_type) {
    errors.payment_type = 'Please select payment type';
  }
  if (!values.payment_date || !moment(values.payment_date).isValid()) {
    errors.payment_date = true;
  }
  return errors;
};

class RecordPaymentForm extends React.Component {
  static renderAmountReceived(field) {
    const {
      meta: { touched, error },
    } = field;
    const className = `form-group ${touched && error ? 'has-error' : ''}`;

    return (
      <div className={className}>
        <label>{field.label}</label>
        <input
          type="tel"
          className="form-control"
          placeholder={field.placeholder}
          {...field.input}
        />
        <span className="help-block">{touched ? error : ''}</span>
      </div>
    );
  }

  render() {
    const { amountDue, createdDate } = this.props;
    return (
      <form id="form-create-payment-record">
        <div className="col-md-12">
          <div className="col-md-6">
            <Field
              component={RecordPaymentForm.renderAmountReceived}
              placeholder="Amount Received"
              id="payment_record_amount_received"
              name="amount_received"
              label="Amount Received (Rp)"
              onChange={event => {
                const { value } = event.target;
                const maxFractionDigits = 3;
                if (!isNaN(value)) {
                  if (maxFractionDigits !== undefined) {
                    const dotPosition = value.indexOf('.');
                    if (
                      dotPosition !== -1 &&
                      value.length - dotPosition - 1 > maxFractionDigits
                    ) {
                      // no operation. invalid change
                    } else if (value > amountDue) {
                      this.props.dispatch(
                        change(
                          'recordPaymentForm',
                          'amount_received',
                          amountDue
                        )
                      );
                    } else {
                      this.props.dispatch(
                        change('recordPaymentForm', 'amount_received', value)
                      );
                    }
                  }
                }
                event.preventDefault();
              }}
            />
          </div>
          <div className="col-md-6">
            <label>Payment Date</label>
            <div className="form-group">
              <Field
                component={MokaDatePicker}
                className="form-control"
                id="payment_record_payment_date"
                name="payment_date"
                minDate={createdDate}
              />
            </div>
          </div>
          <div className="col-md-12 payment-type">
            <label className="col-md-12 payment-type">Payment Type</label>
            <div className="col-md-2 cash">
              <Field
                component="input"
                type="radio"
                value="cash"
                name="payment_type"
              />
              &nbsp;&nbsp;Cash
            </div>
            <div className="col-md-3">
              <Field
                component="input"
                type="radio"
                value="check"
                name="payment_type"
              />
              &nbsp;&nbsp;Check
            </div>
            <div className="col-md-4">
              <Field
                component="input"
                type="radio"
                value="bank_transfer"
                name="payment_type"
              />
              &nbsp;&nbsp;Bank Transfer
            </div>
            <div className="col-md-3">
              <Field
                component="input"
                type="radio"
                value="other"
                name="payment_type"
              />
              &nbsp;&nbsp;Other
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group note">
              <label>Note:</label>
              <Field
                component="textarea"
                className="form-control"
                rows="5"
                maxLength="500"
                id="payment_record_note"
                name="note"
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}

RecordPaymentForm.propTypes = {
  dispatch: PropTypes.func,
  data: PropTypes.object,
  amountDue: PropTypes.number,
};

export default reduxForm({
  form: 'recordPaymentForm', // a unique identifier for this form,
  validate,
})(RecordPaymentForm);
